export default __webpack_public_path__ + "2afa46ececb27289a476f24343d39880.png";